module.exports = __webpack_public_path__ + "static/img/gongzhonghao.1807e010.jpg";